import { useSelector } from 'react-redux'
import { Box, Grid, Typography } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import { selectBeacon4BlendedSeries, selectBeacon4KpiLoading } from '../reducers/Beacon4KpiDataReducer'
import Beacon4KpiLineChart        from './charts/Beacon4KpiLineChart'
import Beacon4StackedTrafficChart from './charts/Beacon4StackedTrafficChart'

const CHART_H = 220

function Beacon4EmptyState() {
  return (
    <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'60vh', gap:2, color:'text.disabled' }}>
      <BarChartIcon sx={{ fontSize:56, opacity:0.3 }} />
      <Typography sx={{ fontSize:15, fontWeight:500 }}>Select your filters and press Apply</Typography>
      <Typography sx={{ fontSize:12 }}>Choose Side, Polygon and date range above</Typography>
    </Box>
  )
}

export default function Beacon4BlendedView() {
  const blendedSeries = useSelector(selectBeacon4BlendedSeries)
  const loading       = useSelector(selectBeacon4KpiLoading)

  if (!Object.keys(blendedSeries).length && !loading) return <Beacon4EmptyState />

  const vtrafDto = blendedSeries['vtraf']
  const dtrafDto = blendedSeries['dtraf']

  return (
    <Box>
      {/* Row 1: Traffic (3+3) + AVAIL (6) */}
      <Grid container spacing={1.25} mb={1.25}>
        <Grid item xs={12} md={3}>
          <Beacon4StackedTrafficChart
            title="Voice Traffic [erl]" unit="erl"
            labels={[...(vtrafDto?.labels ?? [])]}
            seriesList={(vtrafDto?.series ?? []).filter(s => ['2G','3G','4G'].includes(s.key)).map(s => ({ key: s.key, data: [...(s.data ?? [])] }))}
            height={CHART_H}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Beacon4StackedTrafficChart
            title="Data Traffic [MB]" unit="MB"
            labels={[...(dtrafDto?.labels ?? [])]}
            seriesList={(dtrafDto?.series ?? []).filter(s => ['2G','3G','4G'].includes(s.key)).map(s => ({ key: s.key, data: [...(s.data ?? [])] }))}
            height={CHART_H}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Beacon4KpiLineChart title="Blended Availability [AVAIL]" kpiKey="avail" seriesDto={blendedSeries['avail']} height={CHART_H} />
        </Grid>
      </Grid>

      {/* Row 2: VSSR / DSSR */}
      <Grid container spacing={1.25} mb={1.25}>
        <Grid item xs={12} md={6}>
          <Beacon4KpiLineChart title="Blended Voice Setup Success Rate [VSSR]" kpiKey="vssr" seriesDto={blendedSeries['vssr']} height={CHART_H} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Beacon4KpiLineChart title="Blended Data Setup Success Rate [DSSR]" kpiKey="dssr"  seriesDto={blendedSeries['dssr']} height={CHART_H} />
        </Grid>
      </Grid>

      {/* Row 3: VDCR / DDCR */}
      <Grid container spacing={1.25}>
        <Grid item xs={12} md={6}>
          <Beacon4KpiLineChart title="Blended Voice Drop Rate [VDCR]" kpiKey="vdcr" seriesDto={blendedSeries['vdcr']} height={CHART_H} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Beacon4KpiLineChart title="Blended Data Drop Rate [DDCR]" kpiKey="ddcr"  seriesDto={blendedSeries['ddcr']} height={CHART_H} />
        </Grid>
      </Grid>
    </Box>
  )
}